import { useEffect, useState } from 'react';
import UserListPopup from './UserListEdit';
import Pagination from '../../common/Pagination';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import ConfirmPopUp from '../../common/ConfirmPopUp';
import { getRoleListing } from '../../store/slices/RoleUser';
import FullPageLoader from "../../common/FullPageLoader";
import { Tab, Nav } from 'react-bootstrap';
import AddUserPopup from './AddUserPopup';
import { getMasterConfig } from '../../store/slices/common';
import * as HELPER from '../../config/helper';
import { PAGE_NUMBER, ROLE_FEATURES, STATUS_FIELD, STATUS_SUCCESS } from '@src/config/constant';
import { useLanguage } from "@src/context/LanguageContext";

function UserListTable(props: any) {

    const dispatch: any = useDispatch();
    let [userManageList, setUserManageList] = useState<any>([]);
    const [showConfirmation, setShowConfirmation] = useState(false);
    const [idToDelete, setIdToDelete] = useState(0);
    const [showUserPopup, setUserPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [paginationData, setPaginationData] = useState<any>({});
    let [searchText, setSearchText] = useState('');
    let [activeTab, setActiveTab] = useState(1);
    const [showUserRole, setShowUserRole] = useState(false);
    let [roleList, setRoleList] = useState<any>([]);
    let [userDataToEdit, setUserDataToEdit] = useState<any>({});
    let [tabCount, setTabCount] = useState<any>({});
    let [filterData, setFilterData] = useState<any>({});
    const commonState = useSelector((state: any) => state.common);
    const {translations} = useLanguage();

    useEffect(() => {
        if (Object.keys(commonState.common).length === 0) {
            dispatch(getMasterConfig());
        }
        // eslint-disable-next-line
    }, []);

    let vertical_list = commonState?.common?.vertical_list??[];

    const getUserManageListDetails = async (params: any) => {
        // setSearchText('');
        let filters = {
            ...params,
            page_number: params?.page_number ?? PAGE_NUMBER,
            isPaginationApply: true
        }

        setFilterData(filters);

        setLoading(true);
        dispatch(getRoleListing.getUserManagementList(filters)).then((res: any) => {
            setLoading(false);
            if (res && res.status === STATUS_SUCCESS) {

                res.data = res?.data?.map((data: any) =>{
                    let {password, ...rest} = data;
                    return rest });   /// Remove password by default
                setPaginationData({ ...res?.pagination });
                setUserManageList([...res?.data]);
                setTabCount({...res?.tabCount});
            }
        }).catch((err: Error) => {
            setLoading(false);
        })
    };



    const getRoleListDetails = async (params: any) => {
        let filters = {
            // page_number: params?.page_number ?? 1
        }
        dispatch(getRoleListing.getRoleData(filters)).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS && res.data) {
                roleList = res.data.filter((e: any) => e.status === 1).map((e: any) => {
                    return {
                        value: e.id,
                        label: e.roleName
                    }
                })
                setRoleList([...roleList]);
            }
            setLoading(false);
        }).catch((err: Error) => {
            setLoading(false);
        })
    };


    const searchUser = (event: any) => {

        let value = event.target.value;
        setSearchText(value);
    }

    const addNewUser = (action: boolean = true) => {
        setShowUserRole(action);
        document.body.classList.remove("overflow-hidden");

        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const showDeletePopUp = async (action: boolean, id: any) => {
        setIdToDelete(id);
        setShowConfirmation(action);
    }

    const confirmYes = async () => {
        dispatch(getRoleListing.userDelete({ id: idToDelete, is_delete: 1 })).then((res: any) => {
            if (res && res.status === STATUS_SUCCESS) {
                toast.success(res.message);
                getUserManageListDetails({});
            }
        });
        confirmNo();
    };

    const confirmNo = () => {
        setShowConfirmation(false);
    };

    const userEditPopup = (action: boolean, userData: any) => {
        setUserPopup(action);
        action ? setUserDataToEdit(userData) : setUserDataToEdit({}); 
        document.body.classList.remove("overflow-hidden");
        if (action) {
            document.body.classList.add("overflow-hidden");
        }
    }

    const handleRequestData = (params: any) => {
        let apiParams = {
            page_number: params.page_no
        }

        getUserManageListDetails({...filterData, ...apiParams});

    }

    const getApiData = async () => {
        await getUserManageListDetails({});
        await getRoleListDetails({});
    }

    useEffect(() => {
        getApiData();
        // eslint-disable-next-line
    }, []);

    /**
     * ON ENTER SEARCH 
     * @param event 
     */
    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {

            getUserManageListDetails({...filterData, searchKeyword: searchText?.trim() || undefined, page_number: PAGE_NUMBER});
        }
    }
    return (

        <>
            <FullPageLoader show={loading} />
            <div className="top-filter-bg user-management-inner-tabs">
                <div className="selected-chips user-status-tab-chips">
                    <Tab.Container id="left-tabs-example" >

                      <Nav variant="pills" className="flex-column  nav nav-pills">
                            <div className="tab-list">
                                <Nav.Item>
                                    <Nav.Link className={activeTab === 1 ? "active" : ''} onClick={() => { setActiveTab(1); getUserManageListDetails({...filterData, page_number: PAGE_NUMBER,  status: undefined}) }}>{translations.RuleEngine?.['All_Users'] || translations.commonMsg?.loading}<span className='chip-count-span'>{tabCount.count_all_user || 0}</span> </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className={activeTab === 2 ? "active" : ''} onClick={() => { setActiveTab(2); getUserManageListDetails({ ...filterData, page_number: PAGE_NUMBER, status: STATUS_FIELD.ACTIVE }) }}>{translations.RuleEngine?.['Active_Users'] || translations.commonMsg?.loading} <span className='chip-count-span'>{tabCount.count_active_user || 0}</span> </Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link className={activeTab === 3 ? "active" : ''} onClick={() => { setActiveTab(3); getUserManageListDetails({ ...filterData, page_number: PAGE_NUMBER, status: STATUS_FIELD.IN_ACTIVE }) }}>{translations.RuleEngine?.['Inactive_Users'] || translations.commonMsg?.loading}<span className='chip-count-span'>{tabCount.count_inactive_user || 0}</span></Nav.Link>
                                </Nav.Item>
                            </div>
                            <div className='search-user-add-btn'>
                            <fieldset className="search-bx">
                                <div className="material">
                                    <input id="Search" type="text" placeholder={translations.RuleEngine?.['Search_User_Placeholder'] || translations.commonMsg?.loading} onChange={(e: any) => searchUser(e)} value={searchText} className="form-input" onKeyDown={handleKeyDown} />
                                    <i className="ic-search"></i>
                                </div>
                            </fieldset>
                            {
                                HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit' }) &&
                            <button className="btn-line" onClick={() => addNewUser(true)}>
                                <span>{translations.RuleEngine?.['Add_User'] || translations.commonMsg?.loading}</span>
                            </button>
                            }
                            </div>
                        </Nav>
                    </Tab.Container>

                </div>
            </div>


          
                <div className="lead-list-data-table user-managment-table-data">
                    <table>
                        <thead>
                            <tr>
                                <th>{translations.RuleEngine?.['Name'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Mobile_No'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Email'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Reporting_to'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Vertical'] || translations.commonMsg?.loading}</th>
                                <th>{translations.RuleEngine?.['Role_Assigned'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['status'] || translations.commonMsg?.loading}</th>
                                <th>{translations.commonMsg?.['edit'] || translations.commonMsg?.loading}</th>
                                {
                                HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit' }) &&
                                <th>{translations.commonMsg?.['delete'] || translations.commonMsg?.loading}</th>
                                }
                                </tr>
                        </thead>
                        <tbody>
                            {(userManageList && userManageList.length > 0) ? userManageList.map((row: any, index: number) => (
                                <tr key={index}>
                                    <td>{row.name}</td>
                                    <td>{row.mobile}</td>
                                    <td title={row.email}>{row.email}</td>
                                    <td>{row.reportee_name}</td>
                                    <td>{vertical_list?vertical_list[0]?.label:'Carmudi'}</td>
                                    <td>{row.assigned_role_name} </td>
                                    <td><span className={+row.status ? "active-dot" : "inactive-dot"}>{+row.status ? translations.commonMsg?.['active'] || translations.commonMsg?.loading: translations.commonMsg?.['in_active'] || translations.commonMsg?.loading}</span></td>
                                    <td>
                                        <ul className="action-btn">
                                            <li onClick={() => userEditPopup(true, row)}>
                                                <i className="ic-edit"></i>
                                            </li>
                                        </ul>

                                    </td>
                                    {
                                     HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['task_role_assignment'], accessType: 'edit' }) &&
                                    <td className="action-btn">
                                        <ul className="action-btn">
                                            <li onClick={() => showDeletePopUp(true, row.id)}>
                                                <i className="ic-delete"></i>
                                            </li>
                                        </ul>
                                    </td>
                                    }
                                </tr>
                            )) : 
                            <tr><td colSpan={9} style={{ textAlign: 'center' }}>{translations.commonMsg?.['No data found'] || translations.commonMsg?.loading}</td></tr>
                        }
                        </tbody>
                    </table>

                    {(paginationData && paginationData['total'] > 10) && <Pagination paginateData={{
                        page: 1,
                        loading: false,
                        totalLengthWithoutPagination: paginationData['total'],
                        paginationData,
                        filteredData: filterData
                    }}
                        sendRequestDataToParent={handleRequestData} />}

                    {showUserPopup && <UserListPopup
                        showUserPopup={showUserPopup}
                        userEditPopup={(e: boolean) => {
                            userEditPopup(e, {});
                        }}
                        userDetails={userDataToEdit}
                        role_list={roleList}
                        setLoading={setLoading}
                        getUserManageListDetails={(e: any) => {
                            getUserManageListDetails(e)
                        }} 
                        setSearchText = {setSearchText}
                        />}

                    {showUserRole && <AddUserPopup
                        showUserRole={showUserRole}
                        role_list={roleList}
                        setLoading={setLoading}
                        addNewUser={(e: boolean) => {
                            addNewUser(e);
                        }}
                        getUserManageListDetails={(e: any) => {
                            getUserManageListDetails(e)
                        }} 
                        setSearchText = {setSearchText}
                        />}
                    {showConfirmation === false ? ("") : (
                        <ConfirmPopUp
                            confirmNo={confirmNo}
                            confirmYes={confirmYes}
                            message={translations.RuleEngine?.['Delete_User_Msg'] || translations.commonMsg?.loading}
                        />
                    )}
                </div>
            



        </>
    )
}

export default UserListTable

